export { default as Logger } from "./Logger";
export * from "./common";
export { default as PlatformUtil } from "./PlatformUtil";
export * from "./PlatformUtil";
export var ERRORS = {
  ERROR_SESSION_TOKEN_FAILURE: new Error("ERROR_SESSION_TOKEN_FAILURE"),
  CC_TOKENIZATION_BUSINESS_FAULT: new Error("CC_TOKENIZATION_BUSINESS_FAULT"),
  PAYPAL_TOKENIZATION_FAILURE: new Error("PAYPAL_TOKENIZATION_FAILURE"),
  CC_TOKENIZATION_TECHNICAL_FAILURE: new Error("CC_TOKENIZATION_TECHNICAL_FAILURE"),
  PAY_AT_RESTAURANT_NOT_SUPPORTED: new Error("PAY_AT_RESTAURANT_NOT_SUPPORTED"),
  INVALID_ORDER_TOTAL: new Error("INVALID_ORDER_TOTAL"),
  CHECK_NOT_LOADED: new Error("CHECK_NOT_LOADED"),
  CVV_VALIDATION_ERROR: new Error("CVV_VALIDATION_ERROR"),
  ERROR_MAX_ATTEMPTS_REACHED: new Error("ERROR_MAX_ATTEMPTS_REACHED"),
  ERROR_TOKEN_UNKNOWN_FAULT_CASE: new Error("ERROR_TOKEN_UNKNOWN_FAULT_CASE")
};
export var BRAND_ICON;

(function (BRAND_ICON) {
  BRAND_ICON["ALERT_FAIL"] = "alert-fail.svg";
  BRAND_ICON["APPLE_STORE"] = "apple-store.png";
  BRAND_ICON["BACK"] = "back.svg";
  BRAND_ICON["CALENDAR"] = "calendar.svg";
  BRAND_ICON["CARSIDE"] = "carside.svg";
  BRAND_ICON["CART"] = "cart.svg";
  BRAND_ICON["CASH_ICON"] = "cash-icon.svg";
  BRAND_ICON["CHECK_UPDATE"] = "check-update.svg";
  BRAND_ICON["CHECK"] = "check.svg";
  BRAND_ICON["DELIVERY_ICON"] = "delivery-icon.svg";
  BRAND_ICON["DONE_MARK"] = "done-mark.svg";
  BRAND_ICON["GOOGLE_PLAY"] = "google-play.png";
  BRAND_ICON["HOME_ICON"] = "home-icon.svg";
  BRAND_ICON["IN_RESTAURANT"] = "in-restaurant.svg";
  BRAND_ICON["LOCATION"] = "location.svg";
  BRAND_ICON["LOGO"] = "logo.svg";
  BRAND_ICON["LOGO_MOBILE"] = "logo-mob.svg";
  BRAND_ICON["MOB_PAY_UNAVLBL"] = "mob-pay-unavlbl.svg";
  BRAND_ICON["NEXT_ICON"] = "next-icon.svg";
  BRAND_ICON["PAY_CHECK"] = "pay-check.png";
  BRAND_ICON["PAY_PAL"] = "pay-pal.svg";
  BRAND_ICON["PAYATRES_INACTIVE"] = "payatres-inactive.svg";
  BRAND_ICON["PAYATRES"] = "payatres.svg";
  BRAND_ICON["PAYONLINE_ACTIVE"] = "payonline-active.svg";
  BRAND_ICON["PAYONLINE"] = "payonline.svg";
  BRAND_ICON["PAYPAL_LOGO"] = "paypal-logo.png";
  BRAND_ICON["BREADSTICK_TILTED"] = "breadstick-tilted.png";
  BRAND_ICON["PERSONA"] = "persona.svg";
  BRAND_ICON["RADIO"] = "radio.svg";
  BRAND_ICON["RESTAURANT_ICON"] = "restaurant-icon.svg";
  BRAND_ICON["RIGHT_ARROW"] = "right-arrow.svg";
  BRAND_ICON["SECURE_CARD"] = "secure-card.svg";
  BRAND_ICON["SUCCESS_ICON"] = "success-icon.svg";
  BRAND_ICON["TICK_MARK_DISABLED"] = "tick-mark-disabled.svg";
  BRAND_ICON["TICK_MARK_GREEN"] = "tick-mark-green.svg";
  BRAND_ICON["TIME"] = "time.svg";
  BRAND_ICON["WEB_PAY_UNAVLBL"] = "web-pay-unavlbl.svg";
  BRAND_ICON["WORKS_LEAVE"] = "works-leave.png";
  BRAND_ICON["WORKS_PAY"] = "works-pay.png";
  BRAND_ICON["WORKS_SCAN"] = "works-scan.png";
  BRAND_ICON["WORKS_URL"] = "works-url.png";
  BRAND_ICON["DEBIT_CARD_ICON"] = "debit-card-icon.svg";
  BRAND_ICON["GIFT_CARD_ICON"] = "gift-icon.svg";
  BRAND_ICON["HELP_ICON"] = "help-icon.svg";
  BRAND_ICON["LOGO_BK"] = "logo-bk.svg";
  BRAND_ICON["CURBSIDE_ICO_LOCATION"] = "cs-ico-location.svg";
  BRAND_ICON["CURBSIDE_ICO_TIME"] = "cs-ico-time.svg";
  BRAND_ICON["CURBSIDE_ICO_ERROR"] = "cs-ico-error.svg";
  BRAND_ICON["CURBSIDE_ICO_DIRECTION"] = "cs-ico-direction.svg";
  BRAND_ICON["CURBSIDE_ICO_CHECKMARK"] = "cs-ico-checkmark.svg";
  BRAND_ICON["CURBSIDE_ICO_CALL"] = "cs-ico-call.svg";
  BRAND_ICON["CURBSIDE_ICO_RIGHT_ARROW"] = "cs-ico-red-right-arrow.svg";
  BRAND_ICON["CREDIT_CARD"] = "pay-conf-cred-card.png";
  BRAND_ICON["BG_RESTAURANT"] = "cs-bg-restaurant.png";
  BRAND_ICON["EXCEPTION"] = "exception.svg";
  BRAND_ICON["INFO_ICON"] = "delivery-options-info-tooltip.svg";
})(BRAND_ICON || (BRAND_ICON = {}));

export var MONTHS = [{
  code: "Jan",
  val: 1,
  fullName: "January"
}, {
  code: "Feb",
  val: 2,
  fullName: "February"
}, {
  code: "Mar",
  val: 3,
  fullName: "March"
}, {
  code: "Apr",
  val: 4,
  fullName: "April"
}, {
  code: "May",
  val: 5,
  fullName: "May"
}, {
  code: "Jun",
  val: 6,
  fullName: "June"
}, {
  code: "Jul",
  val: 7,
  fullName: "July"
}, {
  code: "Aug",
  val: 8,
  fullName: "August"
}, {
  code: "Sep",
  val: 9,
  fullName: "September"
}, {
  code: "Oct",
  val: 10,
  fullName: "October"
}, {
  code: "Nov",
  val: 11,
  fullName: "November"
}, {
  code: "Dec",
  val: 12,
  fullName: "December"
}];
export var ORDER_TYPES = {
  CATERING_DELIVERY: 2,
  TOGO_DELIVERY: 6,
  TOGO_PICKUP: 0,
  CATERING_PICKUP: 3,
  GIFT_CARD: 1,
  ORDER_AHEAD: 5
};
export var WAITLIST_STATUS_TYPES = {
  UNAVAILABLE: "UNAVAILABLE",
  LONGER_WAIT: "LONGER_WAIT",
  // or TEMPORARILY_UNAVAILABLE
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE_FOR_THIS_LOCATION: "NOT_AVAILABLE_FOR_THIS_LOCATION",
  RESERVATION_ENABLED: "RESERVATION_ENABLED",
  NO_WAIT: "NO_WAIT",
  RESTRICT_WAIT: "RESTRICT_WAIT"
};
export var NRO_STATUS_TYPES = {
  ALREADY_OPEN: 0,
  THRESHOLD_UNDEFINED: 1,
  OPENS_BEFORE_THRESHOLD: 2,
  OPENS_AFTER_THRESHOLD: 3
};
export var ACTION_BUTTON_TYPES = {
  VIEW_MENU_BTN: "label.restdetails.actionbuttons.viewmenu",
  ORDER_AHEAD_BTN: "button.rc.pre_order_dine_in",
  APPLY_NOW_BTN: "label.restdetails.actionbuttons.applynow",
  HAPPY_HOUR_BTN: "label.restdetails.actionbuttons.happyhour",
  LIVE_MUSIC_BTN: "label.restdetails.actionbuttons.livemusic",
  PRIVATE_DINING_BTN: "label.restdetails.actionbuttons.privatedining",
  ORDER_NOW_BTN: "label.restdetails.actionbuttons.orderfromhere"
};
export var WEB_LOCATION_SEARCH_TAB_NAMES = {
  NEARBY: 0,
  MY_LOCATIONS: 1
};
export var WEB_LOCATION_SEARCH_THREE_TAB_NAMES = {
  NEARBY: 0,
  FAVORITES: 1,
  RECENT: 2
};
export var COUNTRIES = [{
  displayName: "United States of America",
  code: "US"
}, {
  displayName: "Canada",
  code: "CA"
}];
export var CANADA_STATES = [{
  displayName: "Alberta",
  code: "AB"
}, {
  displayName: "British Columbia",
  code: "BC"
}, {
  displayName: "Manitoba",
  code: "MB"
}, {
  displayName: "New Brunswick",
  code: "NB"
}, {
  displayName: "Newfoundland and Labrador",
  code: "NL"
}, {
  displayName: "Northwest Territories",
  code: "NT"
}, {
  displayName: "Nova Scotia",
  code: "NS"
}, {
  displayName: "Nunavut",
  code: "NU"
}, {
  displayName: "Ontario",
  code: "ON"
}, {
  displayName: "Prince Edward Island",
  code: "PE"
}, {
  displayName: "Quebec",
  code: "QC"
}, {
  displayName: "Saskatchewan",
  code: "SK"
}, {
  displayName: "Yukon Territory",
  code: "YT"
}];
export var US_STATES = [{
  displayName: "Alabama",
  code: "AL"
}, {
  displayName: "Alaska",
  code: "AK"
}, {
  displayName: "American Samoa",
  code: "AS"
}, {
  displayName: "Arizona",
  code: "AZ"
}, {
  displayName: "Arkansas",
  code: "AR"
}, {
  displayName: "California",
  code: "CA"
}, {
  displayName: "Colorado",
  code: "CO"
}, {
  displayName: "Connecticut",
  code: "CT"
}, {
  displayName: "Delaware",
  code: "DE"
}, {
  displayName: "District Of Columbia",
  code: "DC"
}, {
  displayName: "Federated States Of Micronesia",
  code: "FM"
}, {
  displayName: "Florida",
  code: "FL"
}, {
  displayName: "Georgia",
  code: "GA"
}, {
  displayName: "Guam",
  code: "GU"
}, {
  displayName: "Hawaii",
  code: "HI"
}, {
  displayName: "Idaho",
  code: "ID"
}, {
  displayName: "Illinois",
  code: "IL"
}, {
  displayName: "Indiana",
  code: "IN"
}, {
  displayName: "Iowa",
  code: "IA"
}, {
  displayName: "Kansas",
  code: "KS"
}, {
  displayName: "Kentucky",
  code: "KY"
}, {
  displayName: "Louisiana",
  code: "LA"
}, {
  displayName: "Maine",
  code: "ME"
}, {
  displayName: "Marshall Islands",
  code: "MH"
}, {
  displayName: "Maryland",
  code: "MD"
}, {
  displayName: "Massachusetts",
  code: "MA"
}, {
  displayName: "Michigan",
  code: "MI"
}, {
  displayName: "Minnesota",
  code: "MN"
}, {
  displayName: "Mississippi",
  code: "MS"
}, {
  displayName: "Missouri",
  code: "MO"
}, {
  displayName: "Montana",
  code: "MT"
}, {
  displayName: "Nebraska",
  code: "NE"
}, {
  displayName: "Nevada",
  code: "NV"
}, {
  displayName: "New Hampshire",
  code: "NH"
}, {
  displayName: "New Jersey",
  code: "NJ"
}, {
  displayName: "New Mexico",
  code: "NM"
}, {
  displayName: "New York",
  code: "NY"
}, {
  displayName: "North Carolina",
  code: "NC"
}, {
  displayName: "North Dakota",
  code: "ND"
}, {
  displayName: "Northern Mariana Islands",
  code: "MP"
}, {
  displayName: "Ohio",
  code: "OH"
}, {
  displayName: "Oklahoma",
  code: "OK"
}, {
  displayName: "Oregon",
  code: "OR"
}, {
  displayName: "Palau",
  code: "PW"
}, {
  displayName: "Pennsylvania",
  code: "PA"
}, {
  displayName: "Puerto Rico",
  code: "PR"
}, {
  displayName: "Rhode Island",
  code: "RI"
}, {
  displayName: "South Carolina",
  code: "SC"
}, {
  displayName: "South Dakota",
  code: "SD"
}, {
  displayName: "Tennessee",
  code: "TN"
}, {
  displayName: "Texas",
  code: "TX"
}, {
  displayName: "Utah",
  code: "UT"
}, {
  displayName: "Vermont",
  code: "VT"
}, {
  displayName: "Virgin Islands",
  code: "VI"
}, {
  displayName: "Virginia",
  code: "VA"
}, {
  displayName: "Washington",
  code: "WA"
}, {
  displayName: "West Virginia",
  code: "WV"
}, {
  displayName: "Wisconsin",
  code: "WI"
}, {
  displayName: "Wyoming",
  code: "WY"
}];
export var DEFAULT_MAX_CC_NUMBER_LENGTH = 16;
export var PrivateDiningRequestFormTabs = {
  EventDetails: "EventDetails",
  ContactDetails: "ContactDetails",
  ReviewDetails: "ReviewDetails"
};